import { createAction, props } from '@ngrx/store';
import {
  TimeEntry,
  Expense,
  Invoice,
  MatterBillingSummary,
  TimeEntryListResponse,
  ExpenseListResponse,
  InvoiceListResponse,
  CreateTimeEntryPayload,
  UpdateTimeEntryPayload,
  CreateExpensePayload,
  UpdateExpensePayload,
  CreateInvoicePayload,
  UpdateInvoicePayload,
} from '../../shared/models/billing.model';

// ─── Time Entries ────────────────────────────────────────────────────────────

export const loadTimeEntries = createAction(
  '[Billing] Load Time Entries',
  props<{ matterId?: string; userId?: string; isBilled?: boolean; dateFrom?: string; dateTo?: string; skip?: number; limit?: number }>()
);
export const loadTimeEntriesSuccess = createAction(
  '[Billing] Load Time Entries Success',
  props<{ response: TimeEntryListResponse }>()
);
export const loadTimeEntriesFailure = createAction(
  '[Billing] Load Time Entries Failure',
  props<{ error: string }>()
);

export const createTimeEntry = createAction(
  '[Billing] Create Time Entry',
  props<{ payload: CreateTimeEntryPayload }>()
);
export const createTimeEntrySuccess = createAction(
  '[Billing] Create Time Entry Success',
  props<{ entry: TimeEntry }>()
);
export const createTimeEntryFailure = createAction(
  '[Billing] Create Time Entry Failure',
  props<{ error: string }>()
);

export const updateTimeEntry = createAction(
  '[Billing] Update Time Entry',
  props<{ id: string; payload: UpdateTimeEntryPayload }>()
);
export const updateTimeEntrySuccess = createAction(
  '[Billing] Update Time Entry Success',
  props<{ entry: TimeEntry }>()
);
export const updateTimeEntryFailure = createAction(
  '[Billing] Update Time Entry Failure',
  props<{ error: string }>()
);

export const deleteTimeEntry = createAction(
  '[Billing] Delete Time Entry',
  props<{ id: string }>()
);
export const deleteTimeEntrySuccess = createAction(
  '[Billing] Delete Time Entry Success',
  props<{ id: string }>()
);
export const deleteTimeEntryFailure = createAction(
  '[Billing] Delete Time Entry Failure',
  props<{ error: string }>()
);

// ─── Expenses ────────────────────────────────────────────────────────────────

export const loadExpenses = createAction(
  '[Billing] Load Expenses',
  props<{ matterId?: string; isBilled?: boolean; skip?: number; limit?: number }>()
);
export const loadExpensesSuccess = createAction(
  '[Billing] Load Expenses Success',
  props<{ response: ExpenseListResponse }>()
);
export const loadExpensesFailure = createAction(
  '[Billing] Load Expenses Failure',
  props<{ error: string }>()
);

export const createExpense = createAction(
  '[Billing] Create Expense',
  props<{ payload: CreateExpensePayload }>()
);
export const createExpenseSuccess = createAction(
  '[Billing] Create Expense Success',
  props<{ expense: Expense }>()
);
export const createExpenseFailure = createAction(
  '[Billing] Create Expense Failure',
  props<{ error: string }>()
);

export const updateExpense = createAction(
  '[Billing] Update Expense',
  props<{ id: string; payload: UpdateExpensePayload }>()
);
export const updateExpenseSuccess = createAction(
  '[Billing] Update Expense Success',
  props<{ expense: Expense }>()
);
export const updateExpenseFailure = createAction(
  '[Billing] Update Expense Failure',
  props<{ error: string }>()
);

export const deleteExpense = createAction(
  '[Billing] Delete Expense',
  props<{ id: string }>()
);
export const deleteExpenseSuccess = createAction(
  '[Billing] Delete Expense Success',
  props<{ id: string }>()
);
export const deleteExpenseFailure = createAction(
  '[Billing] Delete Expense Failure',
  props<{ error: string }>()
);

// ─── Invoices ────────────────────────────────────────────────────────────────

export const loadInvoices = createAction(
  '[Billing] Load Invoices',
  props<{ matterId?: string; status?: string; skip?: number; limit?: number }>()
);
export const loadInvoicesSuccess = createAction(
  '[Billing] Load Invoices Success',
  props<{ response: InvoiceListResponse }>()
);
export const loadInvoicesFailure = createAction(
  '[Billing] Load Invoices Failure',
  props<{ error: string }>()
);

export const createInvoice = createAction(
  '[Billing] Create Invoice',
  props<{ payload: CreateInvoicePayload }>()
);
export const createInvoiceSuccess = createAction(
  '[Billing] Create Invoice Success',
  props<{ invoice: Invoice }>()
);
export const createInvoiceFailure = createAction(
  '[Billing] Create Invoice Failure',
  props<{ error: string }>()
);

export const updateInvoice = createAction(
  '[Billing] Update Invoice',
  props<{ id: string; payload: UpdateInvoicePayload }>()
);
export const updateInvoiceSuccess = createAction(
  '[Billing] Update Invoice Success',
  props<{ invoice: Invoice }>()
);
export const updateInvoiceFailure = createAction(
  '[Billing] Update Invoice Failure',
  props<{ error: string }>()
);

// ─── Matter Billing Summary ──────────────────────────────────────────────────

export const loadMatterBillingSummary = createAction(
  '[Billing] Load Matter Billing Summary',
  props<{ matterId: string }>()
);
export const loadMatterBillingSummarySuccess = createAction(
  '[Billing] Load Matter Billing Summary Success',
  props<{ summary: MatterBillingSummary }>()
);
export const loadMatterBillingSummaryFailure = createAction(
  '[Billing] Load Matter Billing Summary Failure',
  props<{ error: string }>()
);

// ─── UI ──────────────────────────────────────────────────────────────────────

export const clearBillingError = createAction('[Billing] Clear Error');
